Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.GridFitType = module.exports.default = {
	NONE: "none",
	PIXEL: "pixel",
	SUBPIXEL: "subpixel"
};